import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const LoadingAnimation = styled.div`
  animation: blink 1s ease-in-out infinite;
  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

type Props = {
  'data-test-id'?: string;
};

const Loading = (props: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <>
      <h2 {...props}>
        {intl.formatMessage({ id: 'analytics.charts.loading' }).slice(0, -3)}
        <LoadingAnimation>.</LoadingAnimation>
        <LoadingAnimation>.</LoadingAnimation>
        <LoadingAnimation>.</LoadingAnimation>
      </h2>
    </>
  );
};

export default Loading;
